// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"5dd684ad","459":"91b01f61","601":"2be05a90"}[chunkId] + ".chunk.js";
};